export default [
  {
    path: '/traductions',
    name: 'translationList',
    component: () => import('@/views/Translation/List.vue'),
    meta: {
      layout: 'content'
    }
  },
  {
    path: '/traductions/:translationKey',
    name: 'translationDetails',
    component: () => import('@/views/Translation/Details.vue'),
    meta: {
      layout: 'content'
    }
  }
]
